/* eslint-disable radix */
/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import {
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Spinner,
} from 'reactstrap';
import DeleteModal from '~/components/DeleteModal';
import { Container } from './styles';

function Card({
  loading,
  handleUpdate,
  setForm,
  form,
  menuData,
  handleDelete,
}) {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  return (
    <Container>
      <h1>Atualizar dados do menu: {menuData.nome}</h1>
      <Form style={{ width: '100%' }} onSubmit={handleUpdate}>
        <Row form>
          <Col md={6}>
            <FormGroup>
              <Label>Nome do menu</Label>
              <Input
                type="text"
                placeholder="Insira o nome do menu"
                maxLength={200}
                onChange={(e) => setForm({ ...form, nome: e.target.value })}
                required
                defaultValue={menuData.nome}
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label>Descrição do menu</Label>
              <Input
                type="text"
                placeholder="Insira a descrição do menu"
                maxLength={500}
                onChange={(e) =>
                  setForm({ ...form, descricao: e.target.value })
                }
                required
                defaultValue={menuData.descricao}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row form>
          <Col md={6}>
            <FormGroup>
              <Label>
                <span>(opcional)</span> Nome da imagem
              </Label>
              <Input
                type="text"
                placeholder="Insira o nome da imagem"
                maxLength={50}
                onChange={(e) =>
                  setForm({ ...form, nomeImagem: e.target.value })
                }
                defaultValue={menuData.nomeImagem}
                required
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup tag="fieldset">
              <Label>Situação cadastral</Label>
              <FormGroup check>
                <Label check>
                  <Input
                    type="radio"
                    name="radio1"
                    onChange={() =>
                      setForm({ ...form, idSituacaoCadastral: 1 })
                    }
                    defaultChecked={menuData.idSituacaoCadastral === 1}
                  />
                  Ativo
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label check>
                  <Input
                    type="radio"
                    name="radio1"
                    onChange={() =>
                      setForm({ ...form, idSituacaoCadastral: 2 })
                    }
                    defaultChecked={menuData.idSituacaoCadastral !== 1}
                  />
                  Inativo
                </Label>
              </FormGroup>
            </FormGroup>
          </Col>
        </Row>
        <Row form>
          <Col md={6}>
            <FormGroup>
              <Label>
                Selecione o tipo de página | Atual:{' '}
                <strong>
                  {menuData.tipoPagina === 'M' ? 'Menu' : 'Opção'}
                </strong>
              </Label>
              <Input
                placeholder="Selecione..."
                type="select"
                onChange={(e) =>
                  setForm({ ...form, tipoPagina: e.target.value })
                }
                defaultValue={menuData.tipoPagina}
              >
                <option value="M">Menu</option>
                <option value="O">Opção</option>
              </Input>
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label>Rota do menu</Label>
              <Input
                type="text"
                disabled={form.tipoPagina !== 'O'}
                defaultValue={menuData.url === null ? null : menuData.url}
                placeholder="Insira a rota"
                onChange={(e) => setForm({ ...form, url: e.target.value })}
                required
              />
            </FormGroup>
          </Col>
        </Row>
        <Row form>
          <Col md={6}>
            <FormGroup>
              <Label for="name">Ordem </Label>
              <Input
                type="number"
                name="ordem"
                id="ordem"
                defaultValue={menuData.ordem}
                max={1000}
                min={0}
                onChange={(e) =>
                  setForm({ ...form, ordem: parseInt(e.target.value) })
                }
                required
              />
            </FormGroup>
          </Col>
          <Col md={6} />
        </Row>
      </Form>

      {loading ? (
        <section>
          <Button color="primary" disabled className="btn2">
            <Spinner size="sm" color="light" />
          </Button>
          <Button color="danger" disabled className="btn1">
            Excluir
          </Button>
        </section>
      ) : (
        <section>
          <Button color="primary" onClick={handleUpdate} className="btn2">
            Atualizar
          </Button>
          <Button outline color="danger" onClick={toggle} className="btn1">
            Excluir
          </Button>
        </section>
      )}
      <DeleteModal
        toggle={toggle}
        modal={modal}
        handleDelete={handleDelete}
        id={menuData.id}
        loading={loading}
      />
    </Container>
  );
}

export default Card;
